import { Component } from 'react';

/**
 * Catches render errors anywhere below it and renders a fallback,
 * logging the React component stack to the console so we can pinpoint
 * the failing component without a full sourcemap.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // Surface the component stack in the console for diagnosis.
    console.error('[ErrorBoundary] crashed:', error);
    console.error('[ErrorBoundary] component stack:\n' + info.componentStack);
    this.setState({ info });
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{
          padding: 32,
          maxWidth: 720,
          margin: '60px auto',
          background: 'var(--bg-glass)',
          border: '1px solid var(--danger)',
          borderRadius: 8,
          fontFamily: 'var(--font-mono)',
          fontSize: 13,
          lineHeight: 1.5,
          color: 'var(--text-primary)',
        }}>
          <h2 style={{ marginTop: 0, color: 'var(--danger)' }}>Something broke while rendering this page</h2>
          <p>The full error + component stack is in the browser console (Cmd/Ctrl+Shift+J → Console tab).</p>
          <pre style={{
            background: 'var(--bg-tertiary)',
            padding: 12,
            borderRadius: 4,
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
            fontSize: 12,
          }}>
{String(this.state.error?.message || this.state.error)}
{this.state.info?.componentStack ? `\n\nComponent stack:${this.state.info.componentStack}` : ''}
          </pre>
          <button
            type="button"
            onClick={() => { try { localStorage.clear(); sessionStorage.clear(); } catch (_) {} window.location.href = window.location.origin; }}
            style={{
              padding: '8px 16px',
              background: 'var(--accent-primary)',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
            }}
          >
            Clear state and reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
